import React from 'react';
import {Menus} from "../../constants";

interface IToolsGallery {
    isLight: boolean;
}

export const ToolsGallery: React.FC<IToolsGallery> = ({isLight}) => {
    // 画廊项目数据
    const galleryItems = Menus[0].children?.map((item, index) => ({
        id: index + 1,
        image: item.icon,
        href: item.href,
        title: item.text,
        description: item.desc
    }));

    return (
        <section id="gallery" className={`py-16 px-4 ${isLight ? 'bg-white' : ''}`}>
            <div className="container mx-auto">
                <h2 className={`text-3xl font-bold text-center mb-12 ${isLight ? 'text-gray-800' : 'text-gray-500'}`}>
                    Magic<span className="text-indigo-600">&nbsp;Tools</span>
                </h2>

                <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-2`}>
                    {galleryItems?.map(item => (
                        <a key={item.id} href={item.href} className={`${isLight ? 'bg-gray-50' : 'bg-gray-500'} cursor-pointer gallery-item h-80 overflow-hidden rounded-xl shadow-md hover:shadow-xl transition`}>
                            <img
                                src={item.image}
                                alt={item.title}
                                className="w-full h-[80%] object-fill transition-transform duration-500 hover:scale-110"
                            />
                            <div className="p-4 flex justify-left text-[12pt]">
                                <h3 style={{
                                    color: isLight ? 'black' : 'white'
                                }} className={`font-bold select-none`}>{item.title}</h3>
                            </div>
                        </a>
                    ))}
                </div>
            </div>
        </section>
    );
};
